<template>
    <div component="ClientSelect" :load="loading">
        <v-autocomplete
            hide-details
            filled
            rounded
            dense
            solo
            :items="getClients"
            class="select"
            label="Client"
            item-text="obchodne_meno"
            item-value="id"
            v-model="selectedClientId"
        >
        </v-autocomplete>
        <div class="state-message" v-if="!selectedClientId && !loading">Please select client</div>
        <div class="state-message state-message-error" v-if="error">{{ error }}</div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import localStorage from 'local-storage';

export const CLIENT_STORAGE_KEY = 'vc.projects.client_id';

export default {
    name: 'ClientSelect',

    data() {
        return {
            loading: false,
            selectedClientId: null,
            error: '',
        };
    },

    mounted() {
        this.loadClients();

        const clientId = parseInt(this.$route.params?.client_id) || parseInt(localStorage(CLIENT_STORAGE_KEY));

        if (clientId) {
            this.selectedClientId = clientId;
            this.fetchClient(clientId);
        }
    },

    methods: {
        ...mapActions({
            loadClients: 'loadClients',
            loadClient: 'loadClient',
        }),

        async fetchClient(id) {
            this.loading = true;
            this.error = '';
            try {
                await this.loadClient(id);
            } catch (e) {
                if (e == 'record_empty') {
                    this.error = 'Selected client not found';
                    localStorage.remove(CLIENT_STORAGE_KEY);
                    return;
                } else {
                    throw e;
                }
            } finally {
                this.loading = false;
            }
        },
    },

    computed: {
        ...mapGetters(['getClients']),
    },

    watch: {
        selectedClientId(newVal, oldVal) {
            const path = `/client/projects/${newVal}`;
            if (newVal != oldVal && path != this.$route.path) {
                this.$router.push({ path });
            }

            if (newVal) {
                localStorage(CLIENT_STORAGE_KEY, newVal);
            }
        },
        '$route.params.client_id': function (newVal, oldVal) {
            if (newVal && parseInt(newVal) !== parseInt(oldVal)) {
                this.fetchClient(newVal);
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ClientSelect'] {
    position: relative;
    &:after {
        right: 26px;
    }
    .state-message {
        position: absolute;
        left: 0;
        bottom: -40px;
        margin: 10px;

        &.state-message-error {
            color: @accent;
        }
    }
}
</style>
